import * as React from 'react';
import getHtmlParserValue from '../../Utilities/get-html-parser-value';
import InfiniteScroll from 'react-infinite-scroll-component';
import { ISearchResultModalViewProps } from './components';
import { ErrorBoundary } from '../../common/components/error-boundary';
import {
    ICategoryHierarchyViewProps,
    IRefineMenuViewProps,
    ISearchResultContainerViewProps,
    ISortByViewProps,
    ITitleViewProps
} from './mfrm-search-result-container';

import { getTelemetryObject, ITelemetryContent, Module, Node } from '@msdyn365-commerce-modules/utilities';
// VSI Customization - Start
import MsDyn365, { getRichTextHtml, HtmlHeadInclude, RichText, Text } from '@msdyn365-commerce/core';
import classnames from 'classnames';
import get from 'lodash/get';
import { ErrorMessage as MFRMErrorMessage } from '../../themes/mattressfirm/custom-components/error-message';
import { ProductSearchResultItems } from './components';
import { IMfrmSearchResultContainerResources } from './mfrm-search-result-container.props.autogenerated';
import { ProductSearchResult } from '@msdyn365-commerce/retail-proxy';
import CustomSkeleton from '../../themes/mattressfirm/custom-components/CustomSkeleton';
// tslint:disable-next-line: cyclomatic-complexity max-func-body-length max-line-length
const MfrmSearchResultContainerView: React.FC<ISearchResultContainerViewProps> = (props) => {
    const {
        SearchResultContainer,
        pagination,
        ProductsContainer,
        ProductSectionContainer,
        choiceSummary,
        clearAllBtn,
        isMobile,
        modalToggle,
        searchResultModal,
        TitleViewProps,
        refineMenu,
        categoryHierarchy,
        sortByOptions,
        CategoryNavContainer,
        RefineAndProductSectionContainer,
        FeatureSearchContainer,
        similarLookProduct,
        slots,
        resources,
        context,
        config: { searchTips },
        refinerRedirect,
        seoDataEntry
    } = props;
    const pageType: string | undefined = context.request.urlTokens.pageType;
    const pageName: string | undefined = context.request.telemetryPageName;
    let mfrmProducts = (props?.data?.listPageState?.result && props?.data?.listPageState?.result?.activeProducts) || [];
    if (mfrmProducts?.length === 1 && mfrmProducts[0]?.ItemId === '' && mfrmProducts[0]?.RecordId === 0) {
        mfrmProducts = [];
    }
    let errorText: RichText | String = '';
    const categoryPage = pageType === 'Category';
    if (!mfrmProducts || mfrmProducts.length === 0) {
        errorText = categoryPage ? resources.resultCategoryNotFoundText : searchTips || resources.resultSearchNotFoundText;
    }

    const categorySEOTitle = props.data.category.result?.ExtensionProperties?.find((attr) => attr.Key === 'CategorySEOTitle')?.Value
        ?.StringValue;
    const categorySEODescription = props.data.category.result?.ExtensionProperties?.find((attr) => attr.Key === 'CategorySEODescription')
        ?.Value?.StringValue;

    const tagsArr = _getSEOMetaTags(props);
    // VSI Customization - Ends
    if (isMobile) {
        return (
            <ErrorBoundary telemetry={props.telemetry}>
                <Module
                    {...SearchResultContainer}
                    className={classnames('ms-search-result-container', errorText ? 'ms-search-result-container__no-search-result' : '')}
                >
                    <HtmlHeadInclude>
                        {tagsArr.map(
                            (tag, index) =>
                                tag?.content && <meta name={tag?.name} content={tag?.content} key={index} /*property={tag?.property}*/ />
                        )}
                    </HtmlHeadInclude>
                    {!errorText || categoryPage ? (
                        <Node className='ms-search-result-container__search-results'>
                            <Node className='ms-search-result-container__results'>
                                {renderTitle(mfrmProducts, TitleViewProps, errorText, resources, pageName)}
                            </Node>
                        </Node>
                    ) : (
                        false
                    )}
                    {!errorText && renderCategoryHierarchy(categoryHierarchy)}
                    {!errorText || categoryPage ? modalToggle : false}
                    {!errorText || categoryPage ? choiceSummary : false}
                    {!errorText || categoryPage ? createSearchResultModal(searchResultModal, refineMenu, sortByOptions, refinerRedirect) : false}
                    {!errorText && <Node {...FeatureSearchContainer}>{similarLookProduct}</Node>}
                    <Node className={errorText && !categoryPage ? 'ms-search-result-container__no-search-result-section' : ''}>
                        <Node
                            className={
                                categoryPage && errorText
                                    ? 'ms-search-result-container__category-error'
                                    : !categoryPage && errorText
                                        ? 'ms-search-result-container__nsrp-error'
                                        : ''
                            }
                        >
                            {errorText && (
                                <div className='ms-search-result-container__error'>
                                    {renderErrorMessage(TitleViewProps, errorText, resources, categoryPage)}
                                    <MFRMErrorMessage errorMsg={errorText} />
                                </div>
                            )}
                            {errorText && categoryPage && <div className='ms-search-result-container__clear-all'>{clearAllBtn}</div>}
                            {errorText && !categoryPage && (
                                <Node className='ms-search-result-container__help-block'>
                                    {slots && slots.nsrpNeedAssistance && slots.nsrpNeedAssistance[0]}
                                </Node>
                            )}
                        </Node>
                    </Node>
                    <Node
                        {...ProductsContainer}
                        className={
                            errorText ? 'ms-search-result-container__no-search-result-container' : 'ms-search-result-container__Products'
                        }
                    >
                        {/* VSI Customization - Start - NSRP Container Slot content rendering */}
                        {errorText &&
                            slots &&
                            slots.nsrpContainer &&
                            slots.nsrpContainer.map((children: React.ReactNode) => {
                                return children;
                            })}
                        {/* VSI Customization - End  */}
                        {!errorText && _renderProductSearchResultItems(props)}
                    </Node>
                    <div className='hidden'>{pagination}</div>
                    {/* VSI Customization - start  */}
                    {_categorySeoCopy(categorySEOTitle, categorySEODescription, seoDataEntry)}
                    {/* VSI Customization - End  */}
                </Module>
            </ErrorBoundary>
        );
    }
    return (
        <ErrorBoundary telemetry={props.telemetry}>
            <Module
                {...SearchResultContainer}
                className={errorText ? 'ms-search-result-container__no-search-result' : 'ms-search-result-container'}
            >
                <HtmlHeadInclude>
                    {tagsArr.map(
                        (tag, index) =>
                            tag?.content && <meta name={tag?.name} content={tag?.content} key={index} />
                    )}
                </HtmlHeadInclude>
                {!errorText || categoryPage ? (
                    <Node className='ms-search-result-container__search-results'>
                        <Node className='ms-search-result-container__results'>
                            {TitleViewProps && renderTitle(mfrmProducts, TitleViewProps, errorText, resources, pageName)}
                        </Node>
                        {sortByOptions && renderSort(sortByOptions)}
                    </Node>
                ) : (
                    false
                )}
                {!errorText || categoryPage ? (
                    <Node className='ms-search-result-container__choice-summary-container'>{choiceSummary}</Node>
                ) : (
                    false
                )}
                {!errorText ? <Node {...CategoryNavContainer}>{categoryHierarchy && renderCategoryHierarchy(categoryHierarchy)}</Node> : false}
                <Node
                    {...RefineAndProductSectionContainer}
                    className={
                        !errorText || categoryPage
                            ? 'ms-search-result-container__refine-product-section'
                            : errorText && !categoryPage
                                ? 'ms-search-result-container__no-search-result-section'
                                : ''
                    }
                >
                    {refinerLoader(refinerRedirect)}
                    {!errorText || categoryPage ? refineMenu && renderRefiner(refineMenu) : false}
                    <Node {...ProductSectionContainer} className={'ms-search-result-container__product-section'}>
                        <Node
                            className={
                                categoryPage && errorText
                                    ? 'ms-search-result-container__category-error'
                                    : !categoryPage && errorText
                                        ? 'ms-search-result-container__nsrp-error'
                                        : ''
                            }
                        >
                            <Node
                                className={
                                    categoryPage && errorText
                                        ? 'ms-search-result-container__category-error-container'
                                        : !categoryPage && errorText
                                            ? 'ms-search-result-container__nsrp-error-container'
                                            : ''
                                }
                            >
                                {errorText && (
                                    <div className='ms-search-result-container__error'>
                                        {renderErrorMessage(TitleViewProps, errorText, resources, categoryPage)}
                                        <MFRMErrorMessage errorMsg={errorText} />
                                    </div>
                                )}
                                {errorText && categoryPage && <div className='ms-search-result-container__clear-all'>{clearAllBtn}</div>}
                                {errorText && !categoryPage && (
                                    <Node className='ms-search-result-container__help-block'>
                                        {slots && slots.nsrpNeedAssistance && slots.nsrpNeedAssistance[0]}
                                    </Node>
                                )}
                            </Node>
                        </Node>
                        {!errorText && <Node {...FeatureSearchContainer}>{similarLookProduct}</Node>}
                        <Node
                            {...ProductsContainer}
                            className={
                                errorText ? 'ms-search-result-container__no-search-result-container' : 'ms-search-result-container__Products'
                            }
                        >
                            {/* VSI Customization for Classes - End */}
                            {/* Commenting out following code as it causes duplicate mattress matcher container */}
                            {/* VSI Customization - Start - NSRP Container Slot content rendering */}
                            {errorText &&
                                slots &&
                                slots.nsrpContainer &&
                                slots.nsrpContainer.map((children: React.ReactNode) => {
                                    return children;
                                })}
                            {/* VSI Customization - End */}
                            {/* {products} */}
                            {!errorText && _renderProductSearchResultItems(props)}
                        </Node>
                        <div className='hidden'>{pagination}</div>
                    </Node>
                </Node>
                {/* VSI Customization - start  */}
                {_categorySeoCopy(categorySEOTitle, categorySEODescription, seoDataEntry)}
                {/* VSI Customization - end  */}
            </Module>
        </ErrorBoundary>
    );
};
// this will add title and description and description to above footer
const _categorySeoCopy = (categorySEOTitle?: string, categorySEODescription?: string, seoDataEntry?: object | undefined): JSX.Element | null => {
    const seoState = seoDataEntry && seoDataEntry['SEO State'];
    const title = seoState === 'Active' ? seoDataEntry && seoDataEntry['H1 Tag'] : categorySEOTitle;
    const description = seoState === 'Active' ? seoDataEntry && seoDataEntry['Seo Overview Copy'] : categorySEODescription;

    return title && description ? (
        <div className='ms-search-result__seo'>
            <Text tag='h2' text={getHtmlParserValue(title)} />
            <div className='ms-search-result__seo-text'>
                <span className='ms-search-result__seo-text-description' dangerouslySetInnerHTML={{ __html: description }} />
            </div>
        </div>
    ) : null;
};

{
    /* VSI Customization - START - 6432 */
}
const _getSEOMetaTags = (props: ISearchResultContainerViewProps) => {
    const { activeRefiners, seoDataEntry } = props;
    const isActiveRefiner = activeRefiners?.length! > 0 || false;
    const seoState = seoDataEntry && seoDataEntry['SEO State'];
    const seoMetaTags = isActiveRefiner && seoState === 'Active' ? seoDataEntry && seoDataEntry['Meta Keywords'] : undefined;
    const categoryPageKeywords = seoMetaTags || _getSEOMetaTagValue(props, 'CategoryPageKeywords');
    const categoryPageKeywordsParser = getHtmlParserValue(categoryPageKeywords);
    return [
        { content: categoryPageKeywordsParser, name: 'keywords' }
    ];
};

const _getSEOMetaTagValue = (props: ISearchResultContainerViewProps, keyValue: string) => {
    return props?.data.category.result?.ExtensionProperties?.find((attr) => attr.Key === keyValue)?.Value?.StringValue;
};


{
    /* VSI Customization - END - 6432 */
}

const _renderProductSearchResultItems = (props: ISearchResultContainerViewProps): JSX.Element | null => {
    try {
        const {
            addedProducts,
            onlyNewProducts,
            resources,
            config: { imageSettings, allowBackNavigation },
            isCategoryPage,
            categoryNameFromSlug,
            showProductsLoader,
            itemsPerPageInitialState
        } = props;
        const breadCrumbType = props.context.app.config.breadcrumbType;
        const allowBack = allowBackNavigation && (breadCrumbType === 'back' || breadCrumbType === 'categoryAndBack');

        let newProducts = MsDyn365.isBrowser && get(props.data.listPageState.result, 'activeProducts') || [];
        let showLoader = true;

        if (addedProducts.length) {
            newProducts = addedProducts;
        }

        if (props.data.listPageState.result?.totalProductCount === addedProducts.length || newProducts.length === 0 || newProducts.length < 24) {
            showLoader = false;
        }

        const mattressMatcherBannerIndex = (props.matcherBannerSlotInd !== undefined && props.matcherBannerSlotInd !== -1) ? props.matcherBannerSlotInd : 0;
        const telemetryContent: ITelemetryContent = getTelemetryObject(
            props.context.request.telemetryPageName!,
            props.friendlyName,
            props.telemetry
        );
        const listName = props.config?.productImpressionListName;
        const isRefinersEnabled = props.data.listPageState.result?.activeFilters && props.data.listPageState.result?.activeFilters.length > 0 || false;
        return (
            <>
                {showProductsLoader ? _renderImageLoader(showProductsLoader, itemsPerPageInitialState, props, mattressMatcherBannerIndex) : <InfiniteScroll
                    dataLength={newProducts.length}
                    next={props.getScrolledProducts}
                    hasMore={showLoader}
                    scrollThreshold={0.5}
                    loader={
                        <div className='ms-infinite-scroll__search-in-progress'>
                            <div className={classnames('msc-waiting', 'msc-waiting-circular')} />
                        </div>
                    }
                >
                    <ErrorBoundary telemetry={props.telemetry}>
                        <ProductSearchResultItems
                            products={newProducts}
                            context={props.context}
                            imageSettings={imageSettings}
                            resources={resources}
                            moduleType={props.typeName}
                            moduleId={props.id}
                            allowBackNavigation={allowBack}
                            telemetryContent={telemetryContent}
                            // @ts-ignore
                            productBadgeAttribute={props.app.config.productBadgeAttribute}
                            mattressMatcherBanner={props.slots.mattressMatcherBanner}
                            mattressMatcherBannerIndex={mattressMatcherBannerIndex}
                            bannerPosition={props.config.showBannerPosition}
                            targetAudienceGroup={props.config.targetAudienceGroup}
                            listName={listName}
                            currentPromoProducts={newProducts}
                            isCategoryPage={isCategoryPage}
                            categoryNameFromSlug={categoryNameFromSlug}
                            onlyNewProducts={onlyNewProducts}
                            isRefinersEnabled={isRefinersEnabled}
                            showBvRatings={props.config.showBVRatings}
                        />
                    </ErrorBoundary>
                </InfiniteScroll>
                }
            </>
        );
    } catch (error) {
        return null;
    }
};

const createSearchResultModal = (
    modalProps: ISearchResultModalViewProps,
    refineMenu: IRefineMenuViewProps,
    sortByDropDown: ISortByViewProps,
    refinerRedirect: boolean
): JSX.Element => {
    return React.cloneElement(
        modalProps.modal,
        {},
        modalProps.modalHeader,
        refinerLoader(refinerRedirect),
        createModalBody(modalProps, refineMenu, sortByDropDown),
        modalProps.modalFooter
    );
};

const createModalBody = (
    props: ISearchResultModalViewProps,
    refineMenu: IRefineMenuViewProps,
    sortByDropDown: ISortByViewProps
): JSX.Element | null => {
    if (sortByDropDown) {
        return React.cloneElement(props.modalBody, {}, renderSort(sortByDropDown), renderRefiner(refineMenu));
    }
    return null;
};

const _renderImageLoader = (isRefinerLoading: boolean, totalSkeletonItems: number, props: ISearchResultContainerViewProps, mattressMatcherBannerIndex?: number): JSX.Element | null => {
    if (isRefinerLoading) {
        let banner = null;
        const shouldShowMattressMatcherBanner = props.slots.mattressMatcherBanner !== undefined;
        if (props.config.showBannerPosition !== undefined && props.config.showBannerPosition >= 0) {
            banner = (<div className='ms-content-block mfrm-category-banner mfrm-mm-banner-global'>
                <CustomSkeleton className='skeleton-dimensions__banner' type='image' />
            </div>);
        }
        const skeletonItemsBeforeBanner = new Array(props.config.showBannerPosition).fill(null);
        const skeletonItemsAfterBanner = new Array(totalSkeletonItems - (props.config.showBannerPosition ? props.config.showBannerPosition : 0)).fill(null);
        return (
            <div className='ms-search-result-container__Products'>
                <ul className='list-unstyled'>
                    {skeletonItemsBeforeBanner.map((_, idx) =>
                    (<div className='skeleton-dimensions' key={idx}>
                        <div className='skeleton-dimensions__product'>
                            <CustomSkeleton type="image" className='skeleton-dimensions__image' />
                            <div className="msc-product__details">
                                <CustomSkeleton type="text" className='skeleton-dimensions__eyebrow' />
                                <CustomSkeleton type="text" className='skeleton-dimensions__ratings' />
                                <CustomSkeleton type="text" className='skeleton-dimensions__title' />
                                <CustomSkeleton type="text" className='skeleton-dimensions__delivery' />
                            </div>
                            <CustomSkeleton type="text" className='skeleton-dimensions__financing' />
                        </div>
                    </div>))}
                </ul>
                {shouldShowMattressMatcherBanner ? banner : null}
                <ul className='list-unstyled'>
                    {skeletonItemsAfterBanner.map((_, idx) =>
                    (<div className='skeleton-dimensions' key={idx}>
                        <div className='skeleton-dimensions__product'>
                            <CustomSkeleton type="image" className='skeleton-dimensions__image' />
                            <div className="msc-product__details">
                                <CustomSkeleton type="text" className='skeleton-dimensions__eyebrow' />
                                <CustomSkeleton type="text" className='skeleton-dimensions__ratings' />
                                <CustomSkeleton type="text" className='skeleton-dimensions__title' />
                                <CustomSkeleton type="text" className='skeleton-dimensions__delivery' />
                            </div>
                            <CustomSkeleton type="text" className='skeleton-dimensions__financing' />
                        </div>
                    </div>))}
                </ul>
            </div>
        );
    }
    return null;
};
const refinerLoader = (isRefinerLoading: boolean): JSX.Element | null => {
    if (isRefinerLoading) {
        return (
            <Node className='ms-search-result-container__screen-loader'>
                <Node className='msc-waiting msc-waiting-circular' />
            </Node>
        );
    }
    return null;
};

const renderRefiner = (props: IRefineMenuViewProps): JSX.Element | null => {
    const { refiners, RefineMenuContainer, RefinerSectionContainer } = props;
    if (refiners) {
        return (
            <Node {...RefinerSectionContainer}>
                <Node {...RefineMenuContainer}>
                    <Node className='ms-refine-submenu__title'>{props.refinerLabel}</Node>
                    {refiners.map((submenu, index) => (
                        <React.Fragment key={index}>{submenu}</React.Fragment>
                    ))}
                </Node>
            </Node>
        );
    }
    return null;
};

const renderSort = (props: ISortByViewProps): JSX.Element | null => {
    const { sortByDropDown } = props;
    if (sortByDropDown) {
        return <div>{sortByDropDown}</div>;
    }
    return null;
};

const renderCategoryHierarchy = (props: ICategoryHierarchyViewProps): JSX.Element | null => {
    const { CategoryHierarchyContainer, categoryHierarchyList, categoryHierarchySeparator } = props;
    if (categoryHierarchyList) {
        return (
            <Node {...CategoryHierarchyContainer}>
                {categoryHierarchyList.map((category, index) => (
                    <React.Fragment key={index}>
                        {category}
                        {categoryHierarchyList && categoryHierarchyList[index + 1] && categoryHierarchySeparator}
                    </React.Fragment>
                ))}
            </Node>
        );
    }

    return null;
};
// VSI Customization - Start
const renderTitle = (
    activeProducts: ProductSearchResult[],
    titleProps: ITitleViewProps,
    errorMsg: RichText | string,
    resources: IMfrmSearchResultContainerResources,
    pageName: string | undefined
): JSX.Element | null => {
    const { title, TitleContainer } = titleProps;
    const extProperties = activeProducts.length > 0 && activeProducts[0]?.ExtensionProperties || [];
    const fallBackQueryResult = extProperties?.find(obj => obj.Key === 'FallbackQuery')?.Value?.StringValue;
    const originalBackQueryResult = extProperties?.find(obj => obj.Key === 'OrignalQuery')?.Value?.StringValue;
    if (title) {
        // tslint:disable: react-no-dangerous-html
        return (
            <Node {...TitleContainer}>
                {
                    <>
                        {fallBackQueryResult === '' && pageName === 'Search' && <>
                            {title.searchPageTitle} <span className='ms-search-result__result-text'>{title.titleCount}</span> <div> {title.titlePrefix} “{title.titleText}” </div>
                        </>}
                        {fallBackQueryResult !== '' && pageName === 'Search' && <>
                            <div className='ms-search-result__incorrect'> You searched for <span className='ms-search-result__incorrect-result'>‘{originalBackQueryResult}’ </span>
                                <span className='ms-search-result__result-text'>{title.titleCount}</span> </div>
                            <div className='ms-search-result__correct'> Showing results for <span className='ms-search-result__correct-result'>‘{fallBackQueryResult}’</span> </div>
                        </>}
                        {pageName !== 'Search' && <> {title.titleText} <span className='ms-search-result__result-text'>{title.titleCount}</span> </>}
                    </>
                }
            </Node>
        );
    }
    return null;
};

const renderErrorMessage = (
    props: ITitleViewProps,
    errorMsg: RichText | string,
    resources: IMfrmSearchResultContainerResources,
    categoryPage: boolean
): JSX.Element | null => {
    const { title } = props;
    const collectionText: string = (get(title.titleText, 'props.children') || '')?.replace(/['']+/g, '');
    const nsrText = resources.mfrmSearchText?.replace('{query}', collectionText)?.replace(/‘[^']*’/g, '<span>$&</span>');
    const noResultsText = resources.mfrmNoResultsText?.replace('{query}', collectionText)?.replace(/‘[^']*’/g, '<span>$&</span>');
    const errorText = categoryPage ? noResultsText : nsrText;

    return (
        <Node className='ms-search-result-container__error-container'>
            {errorMsg ? (
                <p className='ms-search-result-container__error-message' dangerouslySetInnerHTML={getRichTextHtml(errorText)} />
            ) : (
                ''
            )}
        </Node>
    );
};
// VSI Customization - End

export default MfrmSearchResultContainerView;
